import React, { useState } from "react";
import "./InfoCard.css";
import editIcon from "../../assets/images/edit_pencil.png";

interface InfoCardProps {
  title: string;
  details: { label: string; value: string }[];
  onEdit?: (updatedDetails: { label: string; value: string }[]) => void;
  onChangePassword?: () => void;
  borderColor?: string;
  linkText?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  details,
  onEdit,
  onChangePassword,
  borderColor = "#894395",
  linkText,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editableDetails, setEditableDetails] = useState(details);

  const handleEditToggle = () => {
    if (isEditing && onEdit) {
      onEdit(editableDetails); // Send updated details to parent when editing is done
    }
    setIsEditing(!isEditing);
  };

  const handleInputChange = (index: number, value: string) => {
    const updatedDetails = [...editableDetails];
    updatedDetails[index].value = value;
    setEditableDetails(updatedDetails);
  };

  return (
    <div className="info-card" style={{ borderTopColor: borderColor }}>
      <div className="info-card-title-wrapper">
        <h2 className="info-card-title">{title}</h2>
      </div>
      <div className="info-card-details">
        {editableDetails.map((detail, index) => (
          <div className="info-card-detail-row" key={index}>
            <span className="info-card-label">{detail.label}</span>
            {isEditing ? (
              <input
                className="info-card-input"
                type="text"
                value={detail.value}
                onChange={(e) => handleInputChange(index, e.target.value)}
              />
            ) : (
              <span className="info-card-value">{detail.value}</span>
            )}
          </div>
        ))}
      </div>
      {onChangePassword && linkText && (
        <a className="change-password-link" onClick={onChangePassword} href="#">
          {linkText}
        </a>
      )}
      <button className="edit-button" onClick={handleEditToggle}>
        <img src={editIcon} alt="Edit" className="edit-icon" />
        {isEditing ? "Save" : "Edit"}
      </button>
    </div>
  );
};

export default InfoCard;
